// UI-side constants shared across components. Backend config (via
// `[atlas]` user.toml + `atlas-core::config`) governs runtime behaviour
// like hotkey bindings and reverse-image timeouts; *this* file only
// holds presentation thresholds the backend doesn't care about.

/// Seconds since the most recent capture before the elapsed-time
/// indicator turns red. The number is a UX call ("when does the
/// player feel they're behind on the round"), not a contract — keep
/// it here, don't reach for the Rust config file.
export const ROUND_STALE_SECONDS = 45;

/// Toast auto-dismiss in ms. Long enough to read, short enough to
/// not pile up when the user fires multiple actions in quick
/// succession.
export const TOAST_DURATION_MS = 1800;
